import IMG from "../../assets/img/Img";
import { Button } from "../tag/Button";
import { Input } from "../tag/Input";
import { FormField } from "../tag/CustomTag";

export const FeederCard = ({ item, onChange }) => {
    return (
        <div className="h-full flex flex-col p-4 border-2 border-[rgba(0,184,219,0.3)] rounded-xl shadow-[0_0_10px_rgba(6,182,212,0.1)] bg-[rgba(29,41,61,0.7)]">
            <div className="flex justify-between items-start mb-1.5">
                <h3 className="text-[#00D3F3] text-sm font-bold">{item.outlet}번</h3>
                <Button onClick={() => onChange("active", !item.active)} style={{ backgroundImage: `url(${item.active ? IMG.STATE_ON_ICON : IMG.STATE_OFF_ICON})`}} className="w-7 h-7 bg-no-repeat bg-center"></Button>
            </div>
            <FormField label="사료량 (g)" className="mb-3">
                <Input
                    type="text"
                    value={item.quantity}
                    onChange={(e) => onChange("quantity", e.target.value)}
                    className="w-full h-7 border-2 border-[#314158] rounded text-[#FF8904] bg-[#0F172B]"
                />
            </FormField>
            <FormField label="시간 (초)" className="mb-4.5">
                <Input
                    type="text"
                    value={item.time}
                    onChange={(e) => onChange("time", e.target.value)}
                    className="w-full h-7 border-2 border-[#314158] rounded text-[#00D3F3] bg-[#0F172B]"
                />
            </FormField>
            {item.active ? <p className="text-center text-sm text-[#90A1B9]">사용</p>
                         : <p className="text-center text-sm text-[#FB2C36]">미사용</p>
            }
        </div>
    )
}
